<!-- eslint-disable no-irregular-whitespace -->
<template>
  <div class="accountCard text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      bottom
      content-class="accountCard-menu"
    >
      <template #activator="{ on, attrs }">
        <slot name="activator" :attrs="attrs" :on="on" />
      </template>
      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="accountCard-menu_name">
                {{ avatarName }}
                <span v-if="isOwner" class="accountCard-menu_owner">
                  組織管理者
                </span>
              </v-list-item-title>
              <v-list-item-subtitle class="accountCard-menu_email">{{
                userEmail
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-item
            dense
            @click="
              menu = false;
              routerPush({ name: 'account' });
            "
          >
            <v-list-item-icon>
              <img
                class="v-icon"
                src="@/assets/img/icon_24_setting.svg"
                alt=""
              />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'アカウント管理'"> </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item dense @click="logout">
            <v-list-item-icon>
              <img class="v-icon" src="@/assets/img/logout.svg" alt="" />
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="'ログアウト'"> </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <app-dialog-a
      :open="dialogLogoutOpen"
      title="ログアウト"
      @onClose="closeDialogLogout"
    >
      <div class="accountConfigBar_dialog-content">
        ログアウトしてもよろしいですか？
      </div>
      <template #actions>
        <v-btn
          class="accountConfigBar_dialog-btn accountConfigBar_dialog-cancel"
          color="text"
          @click="closeDialogLogout"
        >
          キャンセル
        </v-btn>
        <v-spacer />
        <v-btn
          class="accountConfigBar_dialog-btn accountConfigBar_dialog-ok"
          color="primary"
          :loading="loadingLogout"
          @click="handleLogoutOk"
        >
          ログアウト
        </v-btn>
      </template>
    </app-dialog-a>
  </div>
</template>
<script>
import { authService } from '@/services/auth.service';
import { mapState } from 'vuex';

export default {
  name: 'AccountCard',
  props: {
    isOwner: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
    dialogLogoutOpen: false,
    loadingLogout: false,
    avatar: null,
  }),
  computed: {
    ...mapState({
      userInfo: (state) => state.common.userInfo,
      avatarName: (state) => state.settings.avatarName,
    }),
    userEmail() {
      return this.userInfo && this.userInfo.attributes
        ? this.userInfo.attributes.email
        : null;
    },
  },
  watch: {
    dialogLogoutOpen(val) {
      val || this.closeDialogLogout();
    },
  },
  methods: {
    logout() {
      this.dialogLogoutOpen = true;
    },
    async handleLogoutOk() {
      this.loadingLogout = true;
      try {
        await authService.logout();
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingLogout = false;
      }
    },
    closeDialogLogout() {
      this.dialogLogoutOpen = false;
    },
  },
};
</script>
<style lang="scss">
.accountCard {
  &-menu {
    .v-sheet.v-list:not(.v-sheet--outlined) {
      padding: 0;
    }
    .v-sheet.v-card:not(.v-sheet--outlined) {
      width: 300px;
      height: 165px;
      padding: 8px 0;
      border-radius: 10px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.12);
      background-color: #fff;
    }
    .v-list-item__title {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
    .v-list-item__icon:first-child {
      margin-right: 6px;
    }
    &_owner {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.75;
      letter-spacing: normal;
      text-align: left;
      color: #989898;
      margin-left: 3px;
    }
    &_name {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #666;
    }
    &_email {
      &.v-list-item__subtitle {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.75;
        letter-spacing: normal;
        text-align: left;
        color: #989898 !important;
      }
    }
  }
  &-setting {
    &_icon {
      position: absolute;
      z-index: 1;
      bottom: 6px;
      left: 53px;
    }
  }
}
</style>
